import { Flex } from 'antd';
import { PropsWithChildren } from 'react';

import { ChildrenWrapper, TitleWrapper } from './InfoItem.styles';

type Props = {
  title: string;
};

export const InfoItem: React.FC<PropsWithChildren<Props>> = ({ title, children }) => {
  return (
    <Flex vertical gap={4}>
      <TitleWrapper>{title}</TitleWrapper>
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Flex>
  );
};
